<div [formGroup]="pickupCancelForm">
  <div class="popup-page">
    <div class="row">
      <div class="secondary-details mb-2">
        <i class="icon-mat bi bi-building-fill-x">&nbsp;</i>
        <span>
          {{ 'pickup.cancelPickup.cancelPickup' | translate }}
        </span>
      </div>
      <div class="row mt-2">
        <div class="col-md-12 form-group">
          <label class="col-form-label required-field">
            {{ 'pickup.cancelPickup.confirmationNumber' | translate }} </label
          >:
          <input class="form-control" readonly type="text" formControlName="pickup_id" />
          <app-error-component
            [controlName]="pickupCancelForm.get('pickup_id')"></app-error-component>
        </div>
        <div class="col-md-12 form-group">
          <label class="col-form-label required-field">
            {{ 'pickup.cancelPickup.requesterName' | translate }} </label
          >:
          <input class="form-control" type="text" formControlName="requestorName" />
          <app-error-component
            [controlName]="pickupCancelForm.get('requestorName')"></app-error-component>
        </div>
        <div class="col-md-12 form-group">
          <label class="col-form-label required-field">
            {{ 'pickup.cancelPickup.reason' | translate }} </label
          >:
          <input class="form-control" type="text" formControlName="reason" />
          <app-error-component [controlName]="pickupCancelForm.get('reason')"></app-error-component>
        </div>
      </div>
    </div>
    <mat-dialog-actions align="text-center">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<button
        class="primary-btn me-2 text-center"
        mat-dialog-close=""
        type="button">
        {{ 'global.close' | translate }}
      </button>
      <button
        [disabled]="this.pickupCancelForm.invalid"
        class="primary-btn me-2"
        (click)="cancelPickup()">
        {{ 'pickup.cancelPickup.submit' | translate }}
      </button>
    </mat-dialog-actions>
  </div>
</div>
